// import { Link, useLocation } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import "../styles/Sidebar.css";
// interface User {
//   id: number;
//   name: string;
//   email: string;
//   role_id: number;
//   mobile_number?: string;
// }
// export default function Sidebar() {
//   const location = useLocation();
//     const [user, setUser] = useState<User | null>(null);
//     const [loading, setLoading] = useState(true);
 
//    useEffect(() => {
//      // Get user data from localStorage
//      const userData = localStorage.getItem("user");
//      if (userData) {
//        try {
//          const parsedUser = JSON.parse(userData);
//          setUser(parsedUser);
//        } catch (error) {
//          console.error("Error parsing user data:", error);
//        }
//      }
//      setLoading(false);
//    }, []);
 
//    // Check if user has admin access (role_id: 1, 2, 3, 7, 8)
//    const isAdmin = user?.role_id && [1, 2, 3, 7, 8].includes(user.role_id);
   
//    // Check if user is Global Partner (role_id: 28)
//    const isGlobalPartner = user?.role_id === 28;
 
//    // Get user name for display
//    const getUserName = () => {
//      if (user?.name) {
//        return user.name;
//      }
//      return "User";
//    };
 
//    // Get user role label
//    const getRoleLabel = () => {
//      if (isAdmin) return "Admin";
//      if (isGlobalPartner) return "Global Partner Connect";
//      return "User";
//    };
 
//   return (
//     <div className="sidebar">
//       <nav className="sidebar-nav">
//       {isGlobalPartner && (
//         <Link
//           to="/dashboard"
//           className={`sidebar-link ${
//             location.pathname === "/dashboard" ? "active" : ""
//           }`}
//         >
//           Dashboard
//         </Link>
//       )}
//         {isAdmin && (
//         <Link
//           to="/admin"
//           className={`sidebar-link ${
//             location.pathname === "/admin" ? "active" : ""
//           }`}
//         >
//           City-Wise-leads
//         </Link>
//           )}
//         {/* <Link
//           to="/member-directory"
//           className={`sidebar-link ${
//             location.pathname === "/member-directory" ? "active" : ""
//           }`}
//         >
//           Member Directory
//         </Link> */}
//           {isGlobalPartner && (
//         <Link
//           to="/leads"
//           className={`sidebar-link ${
//             location.pathname === "/leads" ? "active" : ""
//           }`}
//         >
//           Leads
//         </Link>
//       )}

//       </nav>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";

interface User {
  id: number;
  name: string;
  email: string;
  role_id: number;
  mobile_number?: string;
}

export default function Sidebar() {
  const location = useLocation();

  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    try {
      // Read from gp_user instead of user
      const storedUser = localStorage.getItem("gp_user");

      if (storedUser) {
        const parsedUser: User = JSON.parse(storedUser);
        setUser(parsedUser);

        // console.log("User:", parsedUser);
        // console.log("Role:", parsedUser.role_id);
      }
    } catch (error) {
      console.error("Error parsing user:", error);
    }
  }, []);

  const roleId = Number(user?.role_id);

  const isAdmin = [1, 2, 3, 7, 8].includes(roleId);
  const isGlobalPartner = roleId === 28;

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">

        {isGlobalPartner && (
          <>
            <Link
              to="/dashboard"
              className={`sidebar-link ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
            >
              Dashboard
            </Link>

            <Link
              to="/leads"
              className={`sidebar-link ${
                location.pathname === "/leads" ? "active" : ""
              }`}
            >
              Leads
            </Link>
          </>
        )}

        {isAdmin && (
          <Link
            to="/admin"
            className={`sidebar-link ${
              location.pathname === "/admin" ? "active" : ""
            }`}
          >
            City-Wise Leads
          </Link>
        )}

      </nav>
    </div>
  );
}